// extracted by mini-css-extract-plugin
export default {"content":"CS-z","lookName":"DS-z","shopTheLookContainer":"ES-z","productContainer":"FS-z","imageContainer":"GS-z","mainImage":"HS-z"};